// src/utils/url.js

export const isValidHttpUrl = (str = '') => {
  try {
    const u = new URL(str);
    return ['http:', 'https:'].includes(u.protocol);
  } catch {
    return false;
  }
};

export const withUTM = (url, source = 'smartdog', campaign = 'marketplace') => {
  if (!isValidHttpUrl(url)) return url;
  const u = new URL(url);
  if (!u.searchParams.has('utm_source'))
    u.searchParams.set('utm_source', source);
  if (!u.searchParams.has('utm_medium'))
    u.searchParams.set('utm_medium', 'referral');
  if (!u.searchParams.has('utm_campaign'))
    u.searchParams.set('utm_campaign', campaign);
  return u.toString();
};
